import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "TumiBackLogin"
}
const _hoisted_3 = { class: "TumiLogin" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-3" }, " Gelieve het wachtwoord in te vullen om de foto's van het straatfeest te zien. ", -1)
const _hoisted_5 = { class: "TumiForm" }
const _hoisted_6 = { class: "d-grid gap-2 mb-2 mb-3" }
const _hoisted_7 = { class: "TumiErrorLogin mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "TumiTextWarning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Photos = _resolveComponent("Photos")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Photos)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.Auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pass) = $event)),
                placeholder: "Wachtwoord"
              }, null, 512), [
                [_vModelText, _ctx.pass]
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Login && _ctx.Login(...args))),
                  class: "btn btn-primary"
                }, "Log in")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}